import React from "react";

interface PlanIllustrationProps {
  className?: string;
}

export const PlanIllustration: React.FC<PlanIllustrationProps> = ({
  className = "h-24 w-24",
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* Calendar sheet */}
      <rect
        x="22"
        y="26"
        width="76"
        height="68"
        rx="6"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      {/* Header */}
      <rect
        x="22"
        y="26"
        width="76"
        height="16"
        rx="6"
        className="fill-primary-100"
      />
      <path d="M22 42H98" className="stroke-primary-200" strokeWidth="2" />
      {/* Day columns */}
      <rect
        x="32"
        y="50"
        width="8"
        height="8"
        rx="2"
        className="fill-secondary-200"
      />
      <rect
        x="48"
        y="50"
        width="8"
        height="8"
        rx="2"
        className="fill-primary-500"
      />
      <rect
        x="64"
        y="50"
        width="8"
        height="8"
        rx="2"
        className="fill-secondary-200"
      />
      <rect
        x="80"
        y="50"
        width="8"
        height="8"
        rx="2"
        className="fill-secondary-200"
      />
      <rect
        x="32"
        y="66"
        width="8"
        height="8"
        rx="2"
        className="fill-secondary-200"
      />
      <rect
        x="48"
        y="66"
        width="8"
        height="8"
        rx="2"
        className="fill-secondary-200"
      />
      <rect
        x="64"
        y="66"
        width="8"
        height="8"
        rx="2"
        className="fill-primary-300"
      />
      <rect
        x="80"
        y="66"
        width="8"
        height="8"
        rx="2"
        className="fill-secondary-200"
      />
      {/* Fork & spoon */}
      <path
        d="M38 86V96M34 86V92C34 94 36 96 38 96"
        className="stroke-secondary-500"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M48 86C48 84 50 84 50 86V92C50 94 48 94 48 92V86ZM48 86V96"
        className="stroke-secondary-500"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PlanIllustration;
